import { Platform, Dimensions } from 'react-native';
import * as Device from 'expo-device';
import * as ScreenOrientation from 'expo-screen-orientation';
import usePlatformStore from '@/data/store/usePlatformStore';

const usePlatform = () => {
    // Shared orientation state — one native listener for the whole app lives
    // in usePlatformStore instead of one per mounted component.
    const orientation = usePlatformStore(state => state.orientation);
    const firstRender = usePlatformStore(state => !state.isResolved);

    const isWeb = Platform.OS === 'web';
    const isNative = !isWeb;
    const isIos = Platform.OS === 'ios';
    const isAndroid = Platform.OS === 'android';

    // react-native-maps on Android requires a Google Maps API key in
    // AndroidManifest.xml. Until the key is configured via EAS, the MapView
    // crashes on Android (Sentry CHURCH-APP-125). Gate the map tab on Android
    // until the keyed build ships. Remove this once the key is live.
    const isAndroidMapsEnabled = isAndroid ? Boolean(process.env.EXPO_PUBLIC_MAPS_ANDROID_ENABLED) : true;

    const isTablet = Device.deviceType === Device.DeviceType.TABLET;
    const isPhone = Device.deviceType === Device.DeviceType.PHONE;

    const isLandscape = firstRender 
        ? Dimensions.get('window').width > Dimensions.get('window').height 
        : (orientation === ScreenOrientation.Orientation.LANDSCAPE_LEFT || orientation === ScreenOrientation.Orientation.LANDSCAPE_RIGHT);
        
    const isPortrait = firstRender 
        ? Dimensions.get('window').height > Dimensions.get('window').width 
        : (orientation === ScreenOrientation.Orientation.PORTRAIT_UP || orientation === ScreenOrientation.Orientation.PORTRAIT_DOWN);

    
    return {
        isWeb,
        isIos,
        isAndroid,
        isNative,
        isTablet,
        isPhone,
        isLandscape,
        isPortrait,
        isAndroidMapsEnabled,
    };
}

export default usePlatform;